import React, { useState } from 'react';
import Slider from 'react-slick';
import TrustPilot from './TrustPilot';
import { graphql, useStaticQuery } from 'gatsby';
import flagService from '../services/FlagService';
import LitImage from './images/LitImage';
import CustomerReviewCard from './CustomerReviewCard';
import { useEffect } from 'react';

const CustomerReview = ({ heading, mode, isGrid, showMore, setShowMore }) => {
  const [sliderState, setSliderState] = useState({ height: 0, index: 0 });

  // Check if the feature is enabled, if so, we want to just return null.
  // Placed here to skip using the query.
  if (!flagService.Trustpilot) return null;

  const reviewData = query();
  if (
    !reviewData.allTrustpilotReview?.nodes.length ||
    !reviewData.allTrustpilotInfo?.nodes.length
  )
    return null;

  const trustpilotBusinessData = reviewData.allTrustpilotInfo.nodes[0];
  const totalReviews = trustpilotBusinessData.numberOfReviews.total;
  const overallRating = trustpilotBusinessData.score;

  const handleChange = (oldIndex, newIndex) => {
    const totalCardCount = reviewData.allTrustpilotReview?.nodes.length;
    const activeCardCount = document.querySelectorAll(
      '.customer-review-slider div.slick-active',
    ).length;

    let maxHeight = 0;
    for (let i = newIndex; i < newIndex + activeCardCount; i++) {
      const cardIndex = i < totalCardCount ? i : i - totalCardCount;
      const card = document.querySelector(
        `.customer-review-slider div.slick-slide[data-index="${cardIndex}"]`,
      );
      maxHeight = Math.max(maxHeight, card?.clientHeight);
    }
    setSliderState({ height: maxHeight, index: newIndex });
  };

  useEffect(() => handleChange(0, 0), []);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    rows: 1,
    slidesToShow: 3,
    slidesToScroll: 3,
    autoplay: true,
    adaptiveHeight: false,
    autoplaySpeed: 10000,
    arrows: true,
    beforeChange: handleChange,
    responsive: [
      {
        breakpoint: 1250,
        settings: {
          rows: 1,
          infinite: true,
          speed: 500,
          slidesToShow: 2,
          slidesToScroll: 1,

          dots: true,
        },
      },
      {
        breakpoint: 868,
        settings: {
          rows: 2,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  };

  const trustpilotReviewData = reviewData.allTrustpilotReview.nodes;
  const trustpilotReviewDataLength = showMore
    ? trustpilotReviewData
    : trustpilotReviewData.slice(0, 9);

  const reviews = trustpilotReviewData.map((review, index) => (
    <CustomerReviewCard
      review={review}
      key={index}
      image={trustpilotBusinessData.fiveStarsImage}
      logo={trustpilotBusinessData.logoImage}
      onToggleExpand={() => handleChange(0, sliderState.index)}
    />
  ));

  return (
    <div className="bootstrap">
      {/* PurgeCSS include:  DarkMode, LightMode */}
      <div
        className={`customer-review-container ${mode ? mode : 'LightMode'} `}
      >
        <section>
          <div
            className={`${
              isGrid ? 'modular-card-grid' : 'customer-review-container-inner'
            }`}
          >
            {!isGrid && (
              <div className="customer-review-header">
                <LitImage
                  image={reviewData.speechBubble}
                  alt="speech bubble with star"
                />
                <h3 className="text-center">
                  {heading ? heading : 'What our customers say'}
                </h3>
              </div>
            )}
            {!isGrid ? (
              <div className="text-center customer-review-slider">
                <Slider
                  style={{
                    height: sliderState.height,
                    transition: 'height 0.5s ease-out',
                  }}
                  {...sliderSettings}
                >
                  {reviews}
                </Slider>
              </div>
            ) : (
              trustpilotReviewDataLength.map((review, index) => {
                return (
                  <CustomerReviewCard
                    review={review}
                    key={index}
                    image={trustpilotBusinessData.fiveStarsImage}
                    logo={trustpilotBusinessData.logoImage}
                    onToggleExpand={() => handleChange(0, sliderState.index)}
                  />
                );
              })
            )}
          </div>
        </section>
        <TrustPilot
          light={mode ? true : false}
          totalReviews={totalReviews}
          overallRating={overallRating}
          showRating
        />
      </div>
    </div>
  );
};

export default CustomerReview;

const query = () => {
  return useStaticQuery(graphql`
    {
      allTrustpilotReview {
        nodes {
          title
          text
          stars
          consumer {
            displayName
          }
          createdAt(fromNow: true)
          id
        }
      }
      allTrustpilotInfo {
        nodes {
          score
          stars
          numberOfReviews {
            fiveStars
            fourStars
            oneStar
            threeStars
            total
            twoStars
            usedForTrustScoreCalculation
          }
          fiveStarsImage {
            childImageSharp {
              gatsbyImageData(
                quality: 75
                placeholder: BLURRED
                layout: CONSTRAINED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          starsImage {
            childImageSharp {
              gatsbyImageData(
                quality: 75
                placeholder: BLURRED
                layout: CONSTRAINED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          logoImage {
            childImageSharp {
              gatsbyImageData(
                quality: 75
                placeholder: BLURRED
                layout: CONSTRAINED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
      speechBubble: file(
        relativePath: { eq: "home-images/customerSpeechBubble.png" }
      ) {
        childImageSharp {
          gatsbyImageData(
            quality: 75
            placeholder: BLURRED
            layout: CONSTRAINED
            formats: [AUTO, WEBP, AVIF]
            width: 320
          )
        }
      }
    }
  `);
};
